// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__ZlyNf","content":"LoadingAlert_content__T34k4"};